import SystemStat, { Count } from "../models/SystemStat";

export const TYPE_PER_DEVICE_TYPE: string = "PER_DEVICE_TYPE";
export const TYPE_PER_ENROL_CATEGORY: string = "PER_ENROL_CATEGORY";
export const TYPE_PER_REPORT_TYPE: string = "PER_REPORT_TYPE";
export const TYPE_PER_PRESET_TYPE: string = "PER_PRESET_TYPE";
export const TYPE_NOTIFICATION_TYPE: string = "PER_NOTIFICATION_TYPE";
export const TYPE_PER_AREA_TYPE: string = "PER_AREA_TYPE";
export const TYPE_PER_GROUP_TYPE: string = "PER_GROUP_TYPE";
export const TYPE_PER_MESSAGE_TYPE: string = "PER_MESSAGE_TYPE";
export const DEVICE_TYPE_CATEGORY = {
    READERS: "READERS",
    CONTOLLERS: "CONTROLLERS",
    LOCKS: "LOCKS",
    BIOMETRICS: "BIOMETRICS",
    DOOR_CONTROLLERS: "DOOR_CONTROLLERS",
    IO_MODULES: "IO_MODULES",
    OSS_DEVICES: "OSS_DEVICES"
}
export const REPORT_TYPE_CATEGORY = {
    ALL_RPTS: "ALL_RPTS",
    TRANSACTION_RPTS: "TRANSACTION_RPTS",
    TIME_AND_ATTENDANCE_RPTS: "TIME_AND_ATTENDANCE_RPTS",
    ACCESS_CONTROL_RPTS: "ACCESS_CONTROL_RPTS",
    SYSTEM_SETUP_RPTS: "SYSTEM_SETUP_RPTS",
    EMERGENCY_AND_SAFETY_RPTS: "EMERGENCY_AND_SAFETY_RPTS",
    COMPLIANCE_RPTS: "COMPLIANCE_RPTS",
    MY_RPTS: "MY_RPTS"
}

export const PROFILE_TYPE_CATEGORY = {
    CONTROLLERS: "CONTROLLERS",
    MODULES: "MODULES",
    READERS: "READERS",
    BIOMETRICS: "BIOMETRICS",
    ROLES: "ROLES",
    LOCKS: "LOCKS",
    LOCKERS: "LOCKERS"
}

export const IMPROX_READER_TAB_COUNT = {
    ACTIONS:"Actions",
    INPUTS: "Inputs",
    PARAMETERS: "Parameters"
}

export const NOTIFICATION_TYPE_CATEGORY = {
    ALL_NOTIFICATIONS: "ALL_NOTIFICATIONS",
    SCHEDULE_NOTIFICATIONS: "SCHEDULED_REPORTS",
    EVENT_BASED_NOTIFICATIONS: "EVENT_BASED"
}

export const CREDENTIAL_RECOGNITION_TYPE = {
    MOBILE:"MOBILE",
    CARD:"CARD",
    STID_MOBILE:"STID_MOBILE",
    HID_MOBILE_ACCESS:"HID_MOBILE_ACCESS",
    QR_CODE: "QR_CODE",
    FACIAL: "FACIAL",
    FINGER: "FINGER"
}

export const CREDENTIAL_STATES = {
    SUSPEND_WITH_ALARM:"SUSPEND_WITH_ALARM",
    SUSPEND: "SUSPEND",
    ACCESS_OVERRIDE: "ACCESS_OVERRIDE",
    SCHEDULED_TOUR: "SCHEDULED_TOUR",
    NORMAL: "NORMAL",
    SPECIAL_EV1: "SPECIAL_EV1",
    SPECIAL_EV2: "SPECIAL_EV2",
    OSS_SO: "OFFLINE_ENABLED"
}

export const ASSIGNMENT_LIMITS = {
    MAX_ASSIGNMENTS_PER_USER: 100
}

/**
 * Pass one 
 * @param systemStat 
 * @param category 
 * @param categoryId 
 * @returns total count for the given category
 */
export const getCountsCategory = (systemStat: SystemStat, category?: string, categoryId?: string) => {
    let count: Count | undefined = undefined;
    if (category) {
        count = systemStat.totals.counts.find((count) => count.category === category);
    }
    else if (categoryId) {
        count = systemStat.totals.counts.find((count) => count.optCategoryId === parseInt(categoryId));
    }

    return count ? parseInt(count.count) : 0;
}

export enum ReportCategoryName {
    TRANSACTIONAL = 'transactional', // includes reports that relate to events, logs, and transactions within the system.
    TIME_AND_ATTENDANCE = 'timeAndAttendance', // includes reports that relate to employee time tracking, attendance, and scheduling.
    ACCESS_CONTROL = 'accessControl', // includes reports that relate to who can go where, how access is granted, and how it's used. These reports typically involve people, permissions, and zones.
    SYSTEM_SETUP = 'systemSetup', // includes reports that relate to system configuration, infrastructure, and environmental setup.
    EMERGENCY_AND_SAFETY = 'emergencyAndSafety', // includes reports that are safety-focused and relate to emergency scenarios.
    COMPLIANCE = 'compliance',
    MY_REPORTS = 'myReports'
}

export const EXPORT_FORMATS = {
    PDF: 'pdf',
    XLS: 'xls',
    CSV: 'csv'
}

export const AREA_TYPE_TYPE = {
    ACCESS_AREA: "ACCESS_AREA",
    LIFT_AREA: "LIFT_AREA"
}

export const GROUP_TYPE = {
    ACCESS_GROUP: "ACCESS_GROUP",
    FLOOR_GROUP: "FLOOR_GROUP",
    OSS_GROUP: "OSS_GROUP"
}

export const MESSAGE_TYPE = {
    GENERAL: "GENERAL",
    BIOMETRICS: "BIOMETRICS"
}

export const PASSWORD_STATES = {
    PENDING: 0, // We haven't checked the controller's password yet.
    SYSTEM_GENERATED: 1, // The system automatically generated the password.
    USER_DEFINED: 2, // The user set their own password.
    USING_DEFAULT_PWD: 3 // Still using the default password.
}
